import {Injectable} from '@angular/core';
import {remoteAppDB, RemoteAppSnapshot} from './remote-app-db';
import {RemoteAppReady} from '../../models';

@Injectable({providedIn: 'root'})
export class RemoteAppReadyStoreService {
    async saveSnapshot(customerGroupId: number, list: RemoteAppReady[]): Promise<void> {
        const snap: RemoteAppSnapshot = {
            customerGroupId,
            data: list,
            updatedAt: Date.now(),
        };
        await remoteAppDB.snapshots.put(snap);
    }

    async getSnapshot(customerGroupId: number): Promise<RemoteAppSnapshot | undefined> {
        return remoteAppDB.snapshots.get(customerGroupId);
    }

    // opcional: helper para saber se tem cache
    async hasSnapshot(customerGroupId: number): Promise<boolean> {
        return (await this.getSnapshot(customerGroupId)) != null;
    }
}
